import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import type { AddPaymentMethodInput } from '../../../models/subscription';
import { useTranslation } from '@hooks/useTranslation';

export const useAddPaymentMethod = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: AddPaymentMethodInput) =>
      subscriptionService.addPaymentMethod(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['paymentMethods'] });
      toast.success(tActionMessages.paymentMethodAddedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToAddPaymentMethod);
    },
  });
};
